import { useState, useEffect, useCallback } from 'react';
import api from '../services/api';

export function useHrOptions() {
  const [subsidiaries, setSubsidiaries] = useState([]);
  const [companies, setCompanies] = useState([]);
  const [allOrgs, setAllOrgs] = useState([]);
  const [positions, setPositions] = useState([]);
  const [employees, setEmployees] = useState([]);

  const loadOrgs = useCallback(async (params = {}) => {
    const res = await api.get('/hr/organizations/options', { params });
    if (res.data.success) {
      setAllOrgs(res.data.data);
      if (!params.org_type) {
        setSubsidiaries(res.data.data.filter((o) => o.org_type === 2));
      }
    }
  }, []);

  const loadPositions = useCallback(async (params = {}) => {
    const res = await api.get('/hr/positions/options', { params });
    if (res.data.success) setPositions(res.data.data);
  }, []);

  const loadCompanies = useCallback(async () => {
    const res = await api.get('/admin/companies/options');
    if (res.data.success) setCompanies(res.data.data);
  }, []);

  const loadEmployees = useCallback(async () => {
    try {
      const res = await api.get('/hr/employees/options', { skipErrorMessage: true });
      if (res.data.success) setEmployees(res.data.data);
      return res.data.success ? res.data.data : [];
    } catch {
      setEmployees([]);
      return [];
    }
  }, []);

  const loadLevels = useCallback(async () => {
    const res = await api.get('/hr/positions/levels/options');
    return res.data.success ? res.data.data : [];
  }, []);

  const getDeptsBySubsidiary = useCallback((subsidiaryId) => {
    return allOrgs.filter((o) => o.org_type === 3 && o.parent_id === subsidiaryId);
  }, [allOrgs]);

  useEffect(() => {
    loadOrgs();
    loadPositions();
  }, [loadOrgs, loadPositions]);

  return {
    subsidiaries, companies, allOrgs, positions, employees,
    loadOrgs, loadPositions, loadCompanies, loadEmployees, loadLevels, getDeptsBySubsidiary
  };
}
